/**
 * The session lifecycle, in one place.
 *
 * Three screens render this status and two of them offer transitions, so the
 * labels, colours and "what can this become" rules live here rather than being
 * re-typed — a session that reads "Running" in the list and "Active" in the
 * detail is the kind of thing that makes people ask which one is real.
 *
 * Mirrors EducationSession::STATUS_LIST on the backend.
 */

export const SESSION_DRAFT = 'draft';
export const SESSION_ACTIVE = 'active';
export const SESSION_COMPLETED = 'completed';

export const SESSION_STATUS_META = {
  [SESSION_DRAFT]: {
    label: 'Draft',
    color: 'default',
    // Written for a trainer looking at the screen, not for a schema.
    hint: 'Not open yet. Activate it when the session starts and the QR code goes live.',
  },
  [SESSION_ACTIVE]: {
    label: 'Running',
    color: 'green',
    hint: 'Open for registration — attendees can scan the QR code to add themselves.',
  },
  [SESSION_COMPLETED]: {
    label: 'Completed',
    color: 'blue',
    hint: 'Closed. Nobody new can register, but you can still correct competency.',
  },
};

export const sessionStatusMeta = (status) =>
  SESSION_STATUS_META[status] || { label: status || 'Unknown', color: 'default', hint: '' };

/**
 * What a trainer may do next from here.
 *
 * Completed -> active is offered on purpose: a session marked finished before
 * the last person scanned is a mistake with no other way out, and the backend
 * allows the move.
 */
export const sessionTransitions = (status) => {
  switch (status) {
    case SESSION_DRAFT:
      return [{ to: SESSION_ACTIVE, label: 'Activate session', primary: true }];
    case SESSION_ACTIVE:
      return [{ to: SESSION_COMPLETED, label: 'Complete session', primary: false }];
    case SESSION_COMPLETED:
      return [{ to: SESSION_ACTIVE, label: 'Reopen session', primary: false }];
    default:
      return [];
  }
};
